import React from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import Paper from '@mui/material/Paper';
import Hidden from '@mui/material/Hidden';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {Owner} from './Inc';
import Title from './Title';
import StoreImg from './StoreImg';
import useStyles from './Styles';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

interface Props {
    owner:Owner,
    list:any[],
}

const TopFavsList:React.FC<Props> = (props)=> {
	const classes = useStyles();
	return (
        <Paper className={classes.paper} style={{marginBottom:"2em"}}>
            <Title text="スキの履歴"/>
            <Table>
                <TableHead>
                    <TableRow style={{height:"2em"}}>
                        <TableCell className={classes.tableHeadNowrap}>日時</TableCell>
                        <TableCell className={classes.tableHeadNowrap}>商品</TableCell>
                        <Hidden smDown implementation="js">
                            <TableCell className={classes.tableHeadNowrap}>BOX</TableCell>
                        </Hidden>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.list.map( (favs,index)=>{
                        const key = "favs"+index;
                        let fav_type_class = classes.favIcon+" ";
                        if( favs.fav_type_id==="1" ){
                            fav_type_class += classes.favBackColor1;
                        } else if( favs.fav_type_id==="2" ){
                            fav_type_class += classes.favBackColor2;
                        } else if( favs.fav_type_id==="3" ){
                            fav_type_class += classes.favBackColor3;
                        } else if( favs.fav_type_id==="4" ){
                            fav_type_class += classes.favBackColor4;
                        } else if( favs.fav_type_id==="5" ){
                            fav_type_class += classes.favBackColor5;
                        } else if( favs.fav_type_id==="6" ){
                            fav_type_class += classes.favBackColor6;
                        } else if( favs.fav_type_id==="9" ){
                            fav_type_class += classes.favBackColor9;
                        }
        
                        return (
                    <TableRow key={key}>
                        <TableCell className={classes.tableCellNowrap}>{favs.fav_date}<br/>{favs.fav_time}</TableCell>
                        <TableCell className={classes.tableCellDense}>
                            <div className="itemImgName">
                                <div className="img"><StoreImg owner_id={props.owner.owner_id} img_id={favs.img_id} className="imgList"/></div>
                                <div className="itemName">
                                    {favs.item_name}<br/>
                                    <Hidden mdUp implementation="js">
                            <span className={fav_type_class}>
                                {favs.fav_type_id==="1" &&
                                <FontAwesomeIcon icon="heart"/>
                                }
                                {favs.fav_type_id==="2" &&
                                <FontAwesomeIcon icon="redo"/>
                                }
                                {favs.fav_type_id==="3" &&
                                <FontAwesomeIcon icon="lightbulb"/>
                                }
                                {favs.fav_type_id==="4" &&
                                <FontAwesomeIcon icon="seedling"/>
                                }
                                {favs.fav_type_id==="5" &&
                                <FontAwesomeIcon icon="gem"/>
                                }
                                {favs.fav_type_id==="6" &&
                                <FontAwesomeIcon icon="gift"/>
                                }
                                {favs.fav_type_id==="9" &&
                                <FontAwesomeIcon icon="comment"/>
                                }
                                
                                <span style={{marginLeft:"0.5em"}}>{favs.fav_type}</span>
                            </span>
                                    </Hidden>
                                </div>
                            </div>
                        </TableCell>
                        <Hidden smDown implementation="js">
                            <TableCell className={classes.tableCellNowrap}>
                            <span className={fav_type_class}>
                                {favs.fav_type_id==="1" &&
                                <FontAwesomeIcon icon="heart"/>
                                }
                                {favs.fav_type_id==="2" &&
                                <FontAwesomeIcon icon="redo"/>
                                }
                                {favs.fav_type_id==="3" &&
                                <FontAwesomeIcon icon="lightbulb"/>
                                }
                                {favs.fav_type_id==="4" &&
                                <FontAwesomeIcon icon="seedling"/>
                                }
                                {favs.fav_type_id==="5" &&
                                <FontAwesomeIcon icon="gem"/>
                                }
                                {favs.fav_type_id==="6" &&
                                <FontAwesomeIcon icon="gift"/>
                                }
                                {favs.fav_type_id==="9" &&
                                <FontAwesomeIcon icon="comment"/>
                                }
                                
                                <span style={{marginLeft:"0.5em"}}>{favs.fav_type}</span>
                            </span>
                            </TableCell>
                        </Hidden>
                    </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
            {props.owner.owner_id>0 &&
            <nav className={classes.more}>
                <Link to="/fav" className={classes.link}><ArrowForwardIcon/>お気に入りをもっと見る</Link>
            </nav>
            }
        </Paper>
    );
}

export default TopFavsList;
